import React, { useState, useEffect } from "react";
import { Stack } from "@mui/system";
import { Box, Checkbox } from "@mui/material";
import { Typography, TextField, Grid } from "@mui/material";
import deleteIcon from "../../Images/delete_red_icon.svg";
import infoIcon from "../../Images/blue_info.svg";
import "./TCAdmin.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  tcAdminID,
  showtcAdminDetails,
  setdeleteList,
  setfliterDeleteList,
  setcheckedList,
  setflitercheckedList,
} from "../../redux/features/trainingCenterAdmin";
import { API, FOMRS, APP_ROUTES } from "../../globals/constants";
import { useNavigate } from "react-router-dom";

const TCList = ({ res, ondeleteClick }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let title = res?.name;
  let titlelength = title?.length;
  let slicedTitle = title?.slice(0, 20);

  let trainingCenter = res?.studio?.studio_name;
  let trainingCenterLength = trainingCenter?.length;
  let slicedtrainingCenter = trainingCenter?.slice(0, 18);

  const [checked, setChecked] = useState(false);

  let deleteTC = useSelector((state) => state.tcAdminDetail?.deleteList);

  let selectedTC = useSelector((state) => state.tcAdminDetail?.checkedList);

  const checkTCAdmin = (e) => {
    e.stopPropagation();
  };

  const editTCAdmin = (e) => {
    e.stopPropagation();
  };

  const deleteTCAdmin = (e, id) => {
    e.stopPropagation();
    ondeleteClick(id);
  };

  const tcChecked = (e) => {
    setChecked(e.target.checked);
    // console.log('deleteTC', deleteTC);
    // console.log('res', res);
  };

  const selected = () => {
    dispatch(setdeleteList(res.id));
    dispatch(setcheckedList(res));
  };

  let filterdArray = (id) => {
    let filteredList = deleteTC.filter(function (item) {
      console.log("item", item);

      return item !== id;
    });
    dispatch(setfliterDeleteList(filteredList));
    console.log("filteredList", filteredList);
  };

  let filterExportObject = (id) => {
    let filteredcheckedList = selectedTC.filter(function (item) {
      // console.log('item', item.id);
      // console.log('id', id);
      return item.id !== id;
    });
    dispatch(setflitercheckedList(filteredcheckedList));
    // console.log('filteredcheckedList', filteredcheckedList);
  };

  const unselected = (TcId) => {
    // console.log('TcId', TcId.id);
    filterdArray(TcId);
    filterExportObject(TcId);
  };

  useEffect(() => {
    checked ? selected() : unselected(res.id);
  }, [checked]);

  useEffect(() => {
    console.log("abjbdj");
    setChecked(false);
  }, [res]);
  return (
    <div>
      <Box sx={{ bgcolor: "#0C0D16", m: "1%" }} id="TCAdmin">
        <Stack
          direction="row"
          sx={{
            pt: { xs: "0.8%", md: "0.4%" },
            pb: { xs: "1%", md: "0%" },
            // flexDirection: { xs: 'column', sm: 'row' }
          }}
          onClick={() => {
            dispatch(tcAdminID(res?.id));
            dispatch(showtcAdminDetails(true));
          }}
        >
          <Grid container>
            <Grid item xs={9} sm={10} md={11}>
              <Stack
                width={"100%"}
                direction={"row"}
                flexGrow="2"
                justifyContent={"space-around"}
              >
                <Stack direction={"row"} width="80%">
                  <Stack
                    className="checkboxTC"
                    marginTop={{ xs: "4%", md: "0.8%" }}
                  >
                    <Checkbox
                      checked={checked}
                      onChange={(e) => {
                        tcChecked(e);
                      }}
                      onClick={(e) => {
                        checkTCAdmin(e);
                      }}
                    />
                  </Stack>
                  <Stack className="fs-3 mt-Row" width="30%" marginLeft={"2%"}>
                    {titlelength > 20 ? `${slicedTitle}...` : res?.name}
                    {/* {res?.name} */}
                  </Stack>
                  <Stack
                    className="borderRight"
                    sx={{ borderRight: "1px solid #338fee", height: "30px" }}
                  ></Stack>
                  <span className="fs-4 mt-Row mt-left" width="15%">
                    {res?.created_at}
                  </span>
                  <Stack
                    className="borderRight"
                    sx={{ borderRight: "1px solid #338fee", height: "30px" }}
                  ></Stack>
                  <span className="fs-4 mt-Row mt-left" width="25%">
                    Training Center :
                    <span className="fs-3">
                      {trainingCenterLength > 18
                        ? `${slicedtrainingCenter}...`
                        : res?.studio?.studio_name}
                    </span>
                  </span>
                </Stack>
                <Stack
                  display={"flex"}
                  justifyContent={"flex-end"}
                  alignItems="flex-end"
                  sx={{ cursor: "pointer" }}
                >
                  <Box
                    className="TCshowTrainingBox"
                    onClick={() => {
                      navigate(APP_ROUTES.TRAINING_LISTING, {
                        state: {
                          instructor_id: res.id,
                          redirect: "tcAdminTP",
                        },
                      });
                    }}
                  >
                    <div className="showTraining ">Show Trainings</div>
                  </Box>
                </Stack>
              </Stack>

              <Stack
                sx={{
                  borderTop: "1px solid #338fee",
                  // mt: '0.6%',
                  width: "95%",
                  marginLeft: "2.5%",
                }}
              ></Stack>
              <Stack
                marginTop={{ xs: "2%", sm: "0%" }}
                sx={{
                  flexDirection: { xs: "column", sm: "column", md: "row" },
                }}
                justifyContent="space-evenly"
                margin="0.2%"
              >
                <Stack
                  sx={{ padding: "0.8%" }}
                  paddingLeft={{ xs: "5%", md: "0%" }}
                  direction="row"
                >
                  <Stack spacing="1%">
                    <span className="fs-4">
                      Average Session Length :{" "}
                      <span className="fs-3">
                        {res?.avg_sesseion_length
                          ? parseFloat(res?.avg_sesseion_length).toFixed(2)
                          : 0}
                        hrs
                      </span>
                    </span>
                  </Stack>
                </Stack>
                <Stack sx={{ borderRight: "1px solid #338fee" }}></Stack>
                <Stack
                  sx={{ paddingTop: "0.5%" }}
                  paddingLeft={{ xs: "5%", md: "0%" }}
                  direction="row"
                >
                  <span className="fs-4">
                    Total Students :
                    <span className="fs-3">{res?.total_students}</span>
                  </span>
                </Stack>
                <Stack sx={{ borderRight: "1px solid #338fee" }}></Stack>
                <Stack
                  sx={{ paddingTop: "0.5%" }}
                  paddingLeft={{ xs: "5%", md: "0%" }}
                  direction="row"
                >
                  <span className="fs-4">
                    Average no. of Disconnect :
                    <span className="fs-3">
                      {" "}
                      {res?.average_no_of_disconnect}
                    </span>
                  </span>
                </Stack>
                <Stack sx={{ borderRight: "1px solid #338fee" }}></Stack>
                <Stack
                  sx={{ paddingTop: "0.5%" }}
                  paddingLeft={{ xs: "5%", md: "0%" }}
                  direction="row"
                >
                  <span className="fs-4">
                    Total Scheduled Training :
                    <span className="fs-3">
                      {" "}
                      {res?.total_scheduled_trainning}
                    </span>
                  </span>
                </Stack>
              </Stack>
              {/* </Stack> */}
            </Grid>
            <Grid item xs={3} sm={2} md={1}>
              <Box
                width={{ xs: "85%", md: "80%" }}
                sx={{
                  // width: '80%',
                  height: { xs: "100%", md: "95%" },
                  background: "var(--subBoxBG)",
                  borderRadius: 1.5,
                  marginLeft: { xs: "8%", md: "0%" },
                }}
              >
                <Stack direction="column" spacing={{ xs: 2, sm: 1 }}>
                  <Stack
                    direction="row"
                    sx={{ justifyContent: "center", p: "5%" }}
                    marginTop={{ xs: "30%", sm: "10%", md: "8%" }}
                  >
                    <span className="fs-4" midleText>
                      Action
                    </span>
                  </Stack>
                  <Stack
                    direction={{ xs: "column", md: "row" }}
                    spacing={2}
                    sx={{
                      justifyContent: "center",
                      paddingLeft: { xs: "36%", md: "0%" },
                      cursor: "pointer",
                    }}
                  >
                    <Stack>
                      <Stack
                        spacing={1}
                        sx={{ width: 20, height: 20, p: "2%" }}
                      >
                        <img
                          src={infoIcon}
                          alt=""
                          onClick={(e) => {
                            editTCAdmin(e);
                            navigate(APP_ROUTES.ADD_TC_ADMIN, {
                              state: {
                                type: FOMRS.VIEW,
                                id: res.id,
                              },
                            });
                          }}
                        />
                      </Stack>
                    </Stack>
                    <Stack>
                      <Stack
                        spacing={1}
                        sx={{
                          width: 16,
                          height: 16,
                          p: "2%",
                          cursor: "pointer",
                        }}
                      >
                        <img
                          src={deleteIcon}
                          alt=""
                          onClick={(e) => {
                            deleteTCAdmin(e, res.id);
                          }}
                        />
                      </Stack>
                    </Stack>
                  </Stack>
                </Stack>
              </Box>
            </Grid>
          </Grid>
        </Stack>
      </Box>
    </div>
  );
};

export default TCList;
